<template>
  <div>
    <v-toolbar
      flat
      height="50"
    >
      <v-btn
        v-if="$mq === 'xs' || $mq === 'sm' || $mq === 'md'"
        icon
        flat
        @click="closeDrawerMethod"
      >
        <v-icon>close</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        icon
        flat
        @click="reinitialise"
      >
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>
    <div v-if="allowLogin">
      <v-layout
        class="pointer"
        v-if="isMember"
        row
        align-center
        mt-3
        mx-3
        @click="goToMyProfile"
      >
        <v-flex xs3>
          <v-avatar
            slot="activator"
            size="55"
          >
            <img :src="myImg">
          </v-avatar>
        </v-flex>
        <v-flex
          xs9
          pl-2
        >
          <h3>{{ myName }}</h3>
          <span v-if="withLoyalty && membership" class="note">{{ membership.name }}</span><br>
          <span class="note">{{ myPoints }}</span>
        </v-flex>
      </v-layout>
      <v-layout
        v-else-if="authenticated"
        row
        align-center
        mt-3
        mx-3
        class="pointer"
        @click="goToRegister2Page"
      >
        <v-flex xs3>
          <v-avatar
            slot="activator"
            size="55"
          >
            <img :src="myImg">
          </v-avatar>
        </v-flex>
        <v-flex
          xs9
          pl-2
        >
          <h3>{{ myName }}</h3>
          <span class="note">{{ $t('complete_registration') }}</span>
        </v-flex>
      </v-layout>
      <v-layout
        v-else
        row
        align-center
        mt-3
        mx-3
        class="pointer"
        @click="goToSignInPage"
      >
        <v-flex xs3>
          <v-avatar
            slot="activator"
            size="55"
          >
            <img :src="myImg">
          </v-avatar>
        </v-flex>
        <v-flex
          xs9
          pl-2
        >
          <h3>{{ $t('sign_in') }} / {{ $t('sign_up') }}</h3>
        </v-flex>
      </v-layout>
    </div>
    <v-container>
      <queues-div v-if="withQueueNo && queues.length > 0" />
      <v-list
        subheader
        dense
      >
        <v-subheader class="uppercase">{{ $t('option') }}</v-subheader>
        <v-list-tile :to="{ name: 'orders' }">
          <v-list-tile-avatar>
            <v-icon>fa-list-ul</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              <h3>{{ $t('orders') }}</h3>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="enableReservation" :to="{ name: 'reservation_tnc' }">
          <v-list-tile-avatar>
            <v-icon>fas fa-calendar-check</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              <h3>{{ $t('reservations') }}</h3>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <span v-if="isMember && !loginByMemberToken">
          <v-list-tile v-if="showCustomSet" :to="{ name: 'custom_sets' }">
            <v-list-tile-avatar>
              <v-icon>fas fa-star</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                <h3>{{ $t('custom_sets') }}</h3>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="hasDeliveryMode" :to="{ name: 'addresses' }">
            <v-list-tile-avatar>
              <v-icon>fa-map-marked-alt</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                <h3>{{ $t('delivery_address') }}</h3>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <span v-if="mode.paymentMode === 1">
            <v-list-tile :to="{ name: 'bills' }">
              <v-list-tile-avatar>
                <v-icon>fas fa-receipt</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  <h3>{{ $t('pay_bill') }}</h3>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile :to="{ name: 'receipts' }">
              <v-list-tile-avatar>
                <v-icon>attach_money</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  <h3>{{ $t('receipts') }}</h3>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </span>
          <v-list-tile v-if="membershipConfig" :to="{ name: 'membership_purchase' }">
            <v-list-tile-avatar>
              <v-icon>fas fa-id-card</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                <h3>Membership</h3>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="(displayVouchersTo.all || displayVouchersTo.members) && isMember && !loginByMemberToken" :to="{ name: 'my_vouchers' }">
            <v-list-tile-avatar>
              <v-icon>fas fa-gift</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                <h3>My Voucher</h3>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </span>
        <span v-for="sub in submenu"
              :key="sub.id">
          <v-list-tile
            v-if="(membership && sub.visible_to == membership.rate_id) || sub.visible_to == 'everyone'"
            @click="showArticle(sub.id)"
            :to="{ name: 'show_article', params: { submenu_id: sub.id } }"
          >
            <v-list-tile-avatar>
              <v-icon>fas fa-{{ sub.icon_file }}</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                <h3>{{ sub.name }}</h3>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </span>
      </v-list>
      <span v-if="(allowMultiLang || (allowLogin && isMember)) && !loginByMemberToken">
        <v-divider class="mt-1 mb-1" />
        <v-list
          subheader
          dense
        >
          <v-subheader class="uppercase">{{ $t('other_settings') }}</v-subheader>
          <v-list-tile
            v-if="allowMultiLang"
            @click="changeLanguage"
          >
            <v-list-tile-avatar>
              <v-icon>fas fa-language</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                <h3>{{ myLang.text }}</h3>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-if="allowLogin && isMember"
            @click="logout"
          >
            <v-list-tile-avatar>
              <v-icon>exit_to_app</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                <h3>{{ $t('sign_out') }}</h3>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </span>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import QueuesDiv from '~/components/QueuesDiv'
import axios from 'axios'

export default {
  components: {
    'queues-div': QueuesDiv
  },
  props: {
    closeDrawerMethod: {
      type: Function,
      default: () => null
    }
  },
  data () {
    return {
      items: [
        { title: 'Dashboard', icon: 'dashboard', route: { name: 'home' }},
        { title: 'Account', icon: 'account_box', route: { name: 'settings.profile' }}
      ],
      busy: false,
    }
  },
  computed: {
    ...mapGetters('config', [
      'config', 'theme', 'pictures', 'withQueueNo', 'enableMemberPoints',
      'mode', 'rid', 'hasDeliveryMode', 'allowMultiLang', 'language', 'allowLogin',
      'enableReservation', 'withLoyalty', 'gid', 'rid', 'displayVouchersTo'
    ]),
    ...mapGetters('auth', [
      'user', 'authenticated', 'loginByMemberToken'
    ]),
    ...mapGetters('order', [
      'queues'
    ]),
    ...mapGetters('member', [
      'points', 'isMember', 'profile', 'membership', 'membershipConfig'
    ]),
    ...mapGetters('menu', [
      'submenu'
    ]),
    ...mapGetters('cart', [
      'cartQty'
    ]),
    myName () {
      return this.user && this.user.name ? this.user.name + ' ' + this.user.name2 : null
    },
    myImg () {
      return this.user && this.user.photo ? this.user.photo : window.config.sharedPictures + 'user.svg'
    },
    myPoints () {
      return this.enableMemberPoints && this.points !== null ? this.points + ' points' : null
    },
    env () {
      return process.env.NODE_ENV
    },
    myLang () {
      if (this.language == 'en-SG') {
        return {
          text: this.$t('chinese'),
          lang: 'zh-SG'
        }
      }
      return {
        text: this.$t('english'),
        lang: 'en-SG'
      }
    },
    showCustomSet () {
      return (parseInt(this.config.group_id) !== 533)
    }
  },
  methods: {
    goToSignInPage () {
      this.$router.push({ name: 'login' })
    },
    goToRegister2Page () {
      this.$router.push({ name: 'register2' })
    },
    goToMyProfile () {
      if (this.loginByMemberToken){
        return
      }
      this.$router.push({ name: 'profile' })
    },
    async logout () {
      this.closeDrawerMethod()
      this.busy = true

      // Log out the user.
      await this.$store.dispatch('auth/logout')
      this.busy = false

      // Clear all data
      await this.$store.dispatch('resetAllData')

      // Redirect to home page.
      this.$router.push({ name: 'welcome' })
    },
    changeLanguage () {
      this.$i18n.locale = this.myLang.lang
      this.$store.dispatch('config/changeLanguage', this.myLang.lang)
      this.closeDrawerMethod()
    },
    showArticle (submenuId) {
      this.$router.push({ name: 'show_article', params: { submenu_id: submenuId } }).catch(err => {})
    },
    async reinitialise() {
      if (this.cartQty > 0) {
        const text = 'Reinitialise will clear items in your basket. Are you sure?'
        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: 'Reinitialise',
          text: text,
          modal: true,
          buttons: [
            { text: 'Cancel' },
            { text: 'Ok', action: 'reinitialise', path: 'welcome' }
          ]
        })
      } else {
        await this.closeDrawerMethod()
        await this.$store.dispatch('reinitialise')
        this.busy = true
        await this.$store.dispatch('reinitialise')
        this.busy = false
        this.$router.push({ name: 'welcome' })
      }
    }
  },
  async created () {
    if (this.isMember) {
      await this.$store.dispatch('order/updateQueues')
      await this.$store.dispatch('member/fetchProfile')
    }
  },
  // async mounted () {
  //   let membership_name = ''
  //   if (this.user && this.profile.loyalty_group_id) {
  //     await axios.post('/api/users/membership/name', {
  //       loyalty_group_id: this.profile.loyalty_group_id
  //     }).then(function (response) {
  //       membership_name = response.data.membership.name
  //     })
  //     this.membership = membership_name
  //   }
  // }
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.note {
  font-size: 14px;
  color: grey;
}
.uppercase {
  text-transform: uppercase;
}
.upgrade {
  font-size: 12px;
  color: gold;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/NavMenu.vue